import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { colors } from "@material-ui/core";

const theme = createTheme({
  typography: {
    fontFamily: ["Nunito", "Helvetica", "Arial", "sans-serif"].join(","),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    background: {
      dark: "#F4F6F8",
      default: colors.common.white,
      paper: colors.common.white,
    },
    primary: {
      main: "#192A7F",
    },
    secondary: {
      main: "#2196C0",
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },
  },
  overrides: {
    MuiButtonBase: {
      root: { textTransform: "none" },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
    MuiTableCell: {
      head: {
        padding: `10px 8px`,
        fontSize: "1rem",
      },
      body: {
        padding: `4px 8px`,
        fontSize: "0.9rem",
      },
    },
    MuiChip: {
      sizeSmall: {
        display: "inline-flex",
        marginInline: 4,
        marginBlock: 4,
        height: "auto",
        minHeight: 24,
      },
      labelSmall: {
        whiteSpace: "normal",
      },
    },
    MuiOutlinedInput: {
      inputMarginDense: {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
  },
});

export default function AppTheme({ children }) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
